import React from "react";
import { styles as ui } from "stories/Admin";

/** «Bruk offset»-ikon fra designet (finnes ikke i ikonbiblioteket). */
const SlidersIcon: React.FC<{ size?: number; strokeWidth?: number }> = ({
  size = 16,
  strokeWidth = 2,
}) => (
  <svg
    className={ui.icon}
    viewBox="0 0 24 24"
    width={size}
    height={size}
    strokeWidth={strokeWidth}
    aria-hidden="true"
  >
    <path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0M14 4v4M8 10v4M16 16v4" />
  </svg>
);

export default SlidersIcon;
